import React from 'react';
import { Chip } from '@mui/material';

/**
 * @component StatChip
 * @description Number with optional label in a circular chip style
 * @param {Object} props
 * @param {number|string} props.value - The value to display
 * @param {string} [props.label] - Optional label (e.g., "Opens", "Clicks")
 * @returns {JSX.Element}
 */
export function StatChip({ value, label }) {
  const formatNumber = (val) => {
    if (typeof val === 'number') {
      return val.toLocaleString();
    }
    return val;
  };

  const chipLabel = label ? `${formatNumber(value)} ${label}` : formatNumber(value);

  return (
    <Chip
      label={chipLabel}
      variant="outlined"
      size="medium"
      sx={{
        borderRadius: '16px', // More circular
        fontWeight: 500,
        fontSize: '0.875rem',
        px: 0.5,
      }}
    />
  );
}

